import { render, staticRenderFns } from "./temporaryProductDataSheet.vue?vue&type=template&id=79f579a9&scoped=true&"
import script from "./temporaryProductDataSheet.vue?vue&type=script&lang=js&"
export * from "./temporaryProductDataSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f579a9",
  null
  
)

export default component.exports